import { MILESTONES } from '../constants';

export const getMilestones = (km) => {
  return MILESTONES.filter(milestone => km >= milestone.km);
};
